var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0849 12.3946L3.86487 0.784566C3.55162 0.639434 3.20705 0.574955 2.86252 0.596997C2.51798 0.61904 2.18443 0.726905 1.89223 0.910773C1.60003 1.09464 1.35846 1.34867 1.1895 1.64974C1.02055 1.95081 0.929579 2.28936 0.924875 2.63457V25.8446C0.92195 26.1989 1.01048 26.548 1.18192 26.8582C1.35336 27.1683 1.60191 27.429 1.90353 27.615C2.20516 27.801 2.54967 27.906 2.90376 27.92C3.25786 27.9339 3.60956 27.8563 3.92487 27.6946L27.0849 16.0846C27.4279 15.9124 27.7164 15.6481 27.9179 15.3214C28.1195 14.9947 28.2262 14.6184 28.2262 14.2346C28.2262 13.8507 28.1195 13.4744 27.9179 13.1477C27.7164 12.821 27.4279 12.5568 27.0849 12.3846V12.3946Z",
    fill: "#161824"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.48dbb46d2c2e335836ee70bbda5abb4d.svg";
export { ForwardRef as ReactComponent };